import {Component, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {ApiService} from '../../../utils/services/api.service';
import {ActivatedRoute} from '@angular/router';
import {NotificationsService} from 'angular2-notifications';

@Component({
  selector: 'app-deposit',
  templateUrl: './deposit.component.html',
  styleUrls: ['./deposit.component.css']
})

export class DepositComponent implements OnInit {

  public agencyCrossID;

  public organizationID;
  public depositForm: FormGroup;
  public isSaveButtonVisible = false;

  constructor(private apiService: ApiService,
              private activatedRoute: ActivatedRoute,
              private notificationsService:NotificationsService) {
  }

  ngOnInit() {
    this.organizationID = this.activatedRoute.snapshot.parent.params.id;
    this.agencyCrossID = this.activatedRoute.snapshot.params.crossID;

    let depositData = this.activatedRoute.snapshot.data.depositData;

    this.depositForm = new FormGroup({
      'depositAmount': new FormControl(depositData ? depositData.depositAmount : null, Validators.required),
    });

    this.isSaveButtonVisible = depositData ? false : true;

  }

  saveChanges() {
    if (this.depositForm.valid) {
      this.apiService.addDeposit(this.organizationID, this.agencyCrossID, {
        depositAmount: this.depositForm.controls.depositAmount.value,
      }).subscribe(
        (response) => {
          this.isSaveButtonVisible = false;
          this.notificationsService.success('Success', 'Deposit is updated');
        }, error => {
          this.isSaveButtonVisible = true;
          this.notificationsService.error('Error', 'Error occured');
        }
      );
    } else {

    }
  }

}



// WEBPACK FOOTER //
// /var/www/bizisystem-frontend/src/src/app/main/frames/deposit/deposit.component.ts